import React from "react";
import styled from "styled-components";
import { read_timeline_plain_text } from "../../../utils/timeline/timeline_normalization";
import { Timeline_Client_Link } from "../Timeline_Client_Link";
import { Timeline_Offer } from "../Timeline_Offer";

const TimelineLegacyText = styled.p`
    margin: 0;
    min-width: 0;
    color: ${p => p.theme.color};
    overflow-wrap: anywhere;
    white-space: pre-wrap;
`;

// Shows recorded comments and meaningful action labels without generic event headings.
export default function Timeline_Legacy_Activity_Text(props) {
    const text = read_timeline_plain_text(props.event?.text);
    const label = read_timeline_plain_text(props.event?.detail?.label);
    const isSchedule = ["MEETING", "CALLBACK"].includes(props.event?.type);

    return (
        <>
            {!isSchedule && label && label !== text && <TimelineLegacyText>{props.t(label)}</TimelineLegacyText>}
            {text && <TimelineLegacyText>{text}</TimelineLegacyText>}
            {props.event?.detail?.conversion?.ref ? (
                <Timeline_Offer event={{ data: { ref: props.event.detail.conversion.ref } }} t={props.t}></Timeline_Offer>
            ) : null}
            {props.event?.detail?.conversion?.dif ? (
                <Timeline_Client_Link event={{ data: { dif: props.event.detail.conversion.dif } }} t={props.t}></Timeline_Client_Link>
            ) : null}
        </>
    );
};

export { Timeline_Legacy_Activity_Text };
